import { render, staticRenderFns } from "./CompanionOptionsConfirm.vue?vue&type=template&id=625064f8&"
import script from "./CompanionOptionsConfirm.vue?vue&type=script&lang=js&"
export * from "./CompanionOptionsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports